import scrollIntoView from '@/helpers/scrollIntoViewHelper.js'

export default {
  setOverlay({ commit }, { component = '', data = null } = {}) {
    commit('setOverlay', { component, data })
  },

  scrollIntoView(_context, id = '') {
    let type = null
    if (id.startsWith('P-')) {
      type = '.panel'
    } else if (id.startsWith('W-')) {
      type = '.widget'
    } else if (id.startsWith('S-')) {
      type = '.section'
    }

    scrollIntoView((type && `${type}_${id}`) || `[class*="${id}"]`)
  },
}
